import { render, staticRenderFns } from "./CreateUpdateType.vue?vue&type=template&id=4b4e3d86&scoped=true"
import script from "./CreateUpdateType.vue?vue&type=script&lang=js"
export * from "./CreateUpdateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e3d86",
  null
  
)

export default component.exports